import { defineMessages } from 'react-intl';

const scope = 'app.workspace.importList';

export default defineMessages({
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status',
  },
  importBy: {
    id: `${scope}.importBy`,
    defaultMessage: 'Import By',
  },
  importDate: {
    id: `${scope}.importDate`,
    defaultMessage: 'Import Date',
  },
});
